import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getHistoricsReportPagination = (state) =>
  get(state, 'reports.historics.pagination', {});

export const getHistoricsReportFilters = (state) => get(state, 'reports.historics.filters', {});

export const getHistoricsReportNeedFetch = (state) =>
  get(state, 'reports.historics.needFetch', false);

export const getHistoricsReportIsLoading = (state) =>
  get(state, 'reports.historics.isLoading', false);

export const getHistoricsReportRecords = (state) =>
  get(state, 'reports.historics.entities.assets', {});
export const getHistoricsReportRecordsIds = (state) =>
  get(state, 'reports.historics.result.assets', []);

export const getHistoricsReportVisibleRecords = createSelector(
  [getHistoricsReportRecordsIds, getHistoricsReportRecords],
  (ids, assets) => ids.map((id) => assets[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/selectors/historics_report_selectors.js